import { api } from '@alltrails/core/utils/api';

const updateSurfaceTypeIsHidden = (trailId: number, isHidden: boolean) => {
  return api<{ trailId: number; hiddenFromUser: boolean }>(`/api/alltrails/trails/${trailId}/surface_types/hidden`, {
    body: JSON.stringify({ hide_surface_type: isHidden }),
    method: 'PATCH'
  });
};

export default updateSurfaceTypeIsHidden;
